<template>
  <div>
    <ListWrapper
      ref="listWrapper"
      :url="url"
      :addButtonText="$lang.new_evidence"
      @getPermissions="getPermissions"
      @handleAddButton="goToAddEvidence"
    >
      <template slot-scope="{ items }">
        <EvidenceCardList :items="items" :permissions="permissions" />
      </template>
    </ListWrapper>
  </div>
</template>

<script>
import ListWrapper from "@/components/re-design/lists/ListWrapper.vue";
import EvidenceCardList from "./components/EvidenceCardList.vue";
import { pathOr } from "ramda";
import { generateApiUrl, goToRoute, storeDispatcher } from "@/shared/utils";
import { mapActions } from "vuex";

export default {
  components: { ListWrapper, EvidenceCardList },
  data() {
    return {
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "evidence"]);
    },
  },
  methods: {
    ...mapActions(["setAction"]),
    pathOr,
    generateApiUrl,
    goToRoute,
    getPermissions(value) {
      this.permissions = value;
    },
    goToAddEvidence() {
      storeDispatcher("mobileHeaderTitleText", this.$lang.new_evidence);
      storeDispatcher("mobileHeaderBaseRoute", this.$route.name);
      goToRoute("add-evidence", {}, {}, false);
    },
  },
};
</script>
